import { useSelector } from 'react-redux';
import styled from 'styled-components';

import { DiamondLogo, LogoColors } from 'ui/logo';
import { Skeleton } from 'ui/skeleton';
import { spacing, colors } from 'ui/theme';

import { selectThumbnail } from '../../../selectors';
import { WorkflowNodeCampaign } from '../../../types';

const ThumbnailContainer = styled.div`
  width: ${spacing.x4};
  height: ${spacing.x3};
  border-radius: ${spacing.quarter};
  background-color: ${colors.grey5};
  border: ${spacing.single} solid ${colors.grey15};
  position: relative;
  overflow: hidden;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

export const StyledLogo = styled(DiamondLogo)`
  opacity: 30%;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translateX(-50%) translateY(-50%);
`;

type CampaignTemplateThumbnailProps = {
  campaign: WorkflowNodeCampaign;
};

export const CampaignTemplateThumbnailSkeleton = () => (
  <ThumbnailContainer>
    <Skeleton shimmerSpeed={1000} />
  </ThumbnailContainer>
);

export const CampaignTemplateThumbnail = ({ campaign }: CampaignTemplateThumbnailProps) => {
  const showThumbnail = !!campaign.templateId;
  const thumbnailSrc = useSelector(selectThumbnail(campaign.templateId));
  const isLoading = campaign.templateId && thumbnailSrc === undefined;

  if (isLoading) {
    return <CampaignTemplateThumbnailSkeleton />;
  }

  return (
    <ThumbnailContainer>
      {showThumbnail && thumbnailSrc ? (
        <img src={thumbnailSrc} />
      ) : (
        <StyledLogo color={LogoColors.BLACK} height={20} />
      )}
    </ThumbnailContainer>
  );
};
